import { GetCommentOutDto, GetCommentInDto } from "../../../types/comment.dto";

export const GET_COMMENTS_JUDICIAL = "GET_COMMENTS_JUDICIAL";
export const GET_COMMENTS_JUDICIAL_SUCCESS = "GET_COMMENTS_JUDICIAL_SUCCESS";
export const GET_COMMENTS_JUDICIAL_ERROR = "GET_COMMENTS_JUDICIAL_ERROR";
export const RESET_GET_COMMENTS_JUDICIAL = "RESET_GET_COMMENTS_JUDICIAL";

export interface GetCommentsJudicial {
  type: typeof GET_COMMENTS_JUDICIAL;
  payload: GetCommentOutDto;
}

export interface GetCommentsJudicialSuccess {
  type: typeof GET_COMMENTS_JUDICIAL_SUCCESS;
  payload: GetCommentInDto[];
}

export interface GetCommentsJudicialError {
  type: typeof GET_COMMENTS_JUDICIAL_ERROR;
  payload: string | boolean;
}

export interface ResetGetCommentsJudicial {
  type: typeof RESET_GET_COMMENTS_JUDICIAL;
  payload: null;
}

export interface State {
  data: GetCommentInDto[] | null;
  states: {
    loading: boolean;
    success: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
};

export type Actions =
  | GetCommentsJudicial
  | GetCommentsJudicialSuccess
  | GetCommentsJudicialError
  | ResetGetCommentsJudicial;
